import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import useQueryString from '@hooks/useQueryString';
import { CapaQuotationServiceType } from '@generated/graphql';
import { CustomizedTypography } from '@components/Customized';
import FormInputLayout from '../Layout/FormInputLayout';
import { RequestQueryString } from '../types';
import RequestFormFileInputLayout from './RequestFormFileInput';

const ReferenceFileInput: React.FC = () => {
  const {
    query: { serviceType }
  } = useQueryString<RequestQueryString>();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <FormInputLayout
      label="참고파일"
      required={
        serviceType === CapaQuotationServiceType.MechanicalDesign ? true : false
      }
      description={'(jpg, jpeg, png, pptx, pdf, hwp 최대 용량 10M)'}
    >
      <RequestFormFileInputLayout
        serviceType={serviceType as CapaQuotationServiceType}
        quantityLimit={10}
        sizeLimitMB={10}
        type="reference"
        acceptFileFormats=".jpg, .jpeg, .png, .pptx, .pdf, .hwp"
        title={
          !matches && (
            <CustomizedTypography
              variant="body1"
              fontWeight="500"
              color="textPrimary"
              gutterBottoms={4}
            >
              설계에 참고할만한 파일을 끌어다 놓으세요.
            </CustomizedTypography>
          )
        }
        onDragText={
          <>
            <CustomizedTypography
              variant="body1"
              fontWeight="500"
              color="textPrimary"
              gutterBottoms={4}
            >
              끌어다 놓으세요.
            </CustomizedTypography>
            <CustomizedTypography variant="body2" color="textPrimary">
              10장까지 업로드할 수 있습니다.
            </CustomizedTypography>
          </>
        }
        description={
          <CustomizedTypography
            variant="body2"
            color="textPrimary"
            gutterBottoms={16}
          >
            10장까지 업로드할 수 있습니다.
          </CustomizedTypography>
        }
        icon={<></>}
      />
    </FormInputLayout>
  );
};

export default ReferenceFileInput;
